import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem('showroom_token');
            if (token) {
                try {
                    const response = await api.get('/api/auth/me/');
                    setUser(response.data);
                    localStorage.setItem('showroom_user', JSON.stringify(response.data));
                } catch (error) {
                    console.error('Initial auth check failed:', error);
                    logout();
                }
            }
            setLoading(false);
        };
        checkAuth();
    }, []);

    const getProfile = async () => {
        try {
            const response = await api.get('/api/auth/me/');
            setUser(response.data);
            localStorage.setItem('showroom_user', JSON.stringify(response.data));
            return response.data;
        } catch (error) {
            console.error('Profile fetch error:', error);
            return null;
        }
    };

    const login = async (email, password) => {
        try {
            const response = await api.post('/api/auth/login/', { email, password });
            const { access, token } = response.data;
            const authToken = token || access;

            localStorage.setItem('showroom_token', authToken);

            // Verify profile with 'me' API after getting token
            const userProfile = await getProfile();

            if (userProfile) {
                return { success: true, user: userProfile };
            } else {
                throw new Error('Failed to fetch user profile');
            }
        } catch (error) {
            console.error('Login error:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Email ou mot de passe incorrect'
            };
        }
    };

    const signup = async (userData) => {
        try {
            const { confirmPassword, ...registerData } = userData;
            const response = await api.post('/api/auth/register/', registerData);
            const { access, token } = response.data;
            const authToken = token || access;

            localStorage.setItem('showroom_token', authToken);

            const userProfile = await getProfile();

            if (userProfile) {
                return { success: true, user: userProfile };
            } else {
                throw new Error('Failed to fetch user profile after signup');
            }
        } catch (error) {
            console.error('Signup error:', error);
            return {
                success: false,
                message: error.response?.data?.message || "Erreur lors de l'inscription"
            };
        }
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('showroom_user');
        localStorage.removeItem('showroom_token');
    };

    return (
        <UserContext.Provider value={{ user, login, signup, logout, loading, getProfile }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};

